module.exports = __webpack_public_path__ + "static/media/github.ddc25012.svg";